import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";

import { useAuth } from "./authContext";
import apiService from "../services/apiService"; // Import your API service

import { cartSession } from "../utils/cart";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const didFetch = useRef(false);
  const { isAuthenticated } = useAuth(); // Use your authentication context

  const [cartCount, setCartCount] = useState(0);

  // Fetch cart items on page load
  useEffect(() => {
    if (didFetch.current) return; // Prevent second call
    didFetch.current = true;

    const fetchCart = async () => {
      try {
        const apiURL = isAuthenticated
          ? `/cart/${cartSession.get("cartId")}`
          : `/cart?sessionId=${cartSession.get()}`;
        const response = await apiService.get(apiURL);
        setCartCount(response?.CartItems?.length || 0);
      } catch (error) {
        console.error("Error fetching cart:", error);
      }
    };

    fetchCart();
  }, [isAuthenticated]);

  const updateCartCount = (count) => {
    setCartCount(count);
  };

  return (
    <CartContext.Provider value={{ cartCount, updateCartCount }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
